import axios from 'axios';
import ACTION_ITEMS from '../actionItems';

export function fetchAllProjects() {
  return (dispatch) => {
    axios
      .get(`/projects`)
      .then((response) => {
        const { status, projects } = response.data;
        if (status === 'SUCCESS') {
          dispatch(setProjects(projects));
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

function setProjects(projects) {
  return {
    type: ACTION_ITEMS.PROJECT_BUILDER.PROJECT.SET,
    payload: projects,
  };
}
